import { Container } from "@mui/material";
import NertzGrid from "./NertzGrid";

function NertzPortal() {
  return (
    <Container id="nertz-portal" maxWidth="md">
      <NertzGrid />
    </Container>
  );
}

export default NertzPortal;
